import { FC } from "react";
import { ActivityDataWithType } from "../types";
import {
  CashActivity,
  CashActivityAction,
  CashActivityDataWithMeta,
} from "./types";
import Container, { EmptyContainer } from "../../meta-container";
import { CashRecvActivity } from "./cash-recv-activity";
import { CashSpendActivity } from "./cash-spend-activity";
import { CashUpdateActivity } from "./cash-update-activity";
import { CashDeleteActivity } from "./cash-delete-activity";

const CashActivityRenderer: FC<ActivityDataWithType> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as CashActivity;

  return (
    <Container<CashActivityAction, CashActivityDataWithMeta>
      data={{ activity: activity_.data, by, date, type }}
      type={activity_.action}
      match={{
        [CashActivityAction.None]: EmptyContainer,
        [CashActivityAction.Recv]: CashRecvActivity,
        [CashActivityAction.Spend]: CashSpendActivity,
        [CashActivityAction.Update]: CashUpdateActivity,
        [CashActivityAction.Delete]: CashDeleteActivity,
      }}
    />
  );
};

export default CashActivityRenderer;
